import { Tooltip } from "devextreme-react";
import { Position } from "devextreme-react/tooltip";

export function headerRenderer(id?: string, firstRow?: string, second?: string, className = "") {
  return (
    <div
      id={id}
      className={`group relative mt-auto flex w-full flex-col items-center justify-center p-4 text-sm leading-tight print:px-1 print:!text-[9px] print:leading-tight ${className}`}
    >
      <span className={`text-center uppercase`}>{firstRow}</span>
      {second ? <span className={`text-center uppercase`}>{second}</span> : null}
    </div>
  );
}

export function cellRenderer<T extends React.ReactNode>(
  cellData: any,
  id: string | undefined,
  value: T,
  comment?: string,
  className = ""
) {
  return (
    <div
      id={`${id}-${cellData?.rowIndex}`}
      key={`${id}-${cellData?.rowIndex}`}
      className={`relative py-[0.8438rem] text-sm print:px-1 print:py-1 print:!text-[10px] ${className}`}
    >
      {value ? value : ""}
      {comment ? (
        <img className="absolute right-0 top-0 print:h-2 print:w-2" src="/icons/note-cell.svg" />
      ) : null}
      {comment ? (
        <Tooltip
          target={`#${id}-${cellData?.rowIndex}`}
          showEvent="mouseenter"
          hideEvent="mouseleave"
          hideOnOutsideClick={false}
        >
          <Position at={"right top"} my={"bottom"} offset={{ x: 65, y: 30 }} />
          <div className="h-fit max-w-[100px] whitespace-pre-line break-words">{comment}</div>
        </Tooltip>
      ) : null}
    </div>
  );
}
